import { render, staticRenderFns } from "./EdiTrailerDisplay.vue?vue&type=template&id=611a3449&scoped=true"
import script from "./EdiTrailerDisplay.vue?vue&type=script&lang=js"
export * from "./EdiTrailerDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a3449",
  null
  
)

export default component.exports